<template>
  <div class="loans">
    <h1 class="header">Loan Accounts</h1>

    <div class="card-container" v-for="(student, index) in liabs">
      <div class="card-topline">
        <h3 class="card-title">{{ student.guarantor }}</h3>
        <p class="card-total">
          <span>${{ student.origination_principal_amount }}</span>
        </p>
      </div>
      <div
        id="progress-bar"
        class="green"
        v-bind:style="{ animationName: `roll-${rollNumber(student.origination_principal_amount, student.currentBalance)}` }"
      ></div>
      <div class="card">
        <div class="table">
          <p class="table-text">Int. Rate</p>
          <p class="table-data">%{{ student.interest_rate_percentage }}</p>
          <p class="table-text">Last Payment</p>
          <p class="table-data">{{ student.last_payment_date }}</p>
          <p class="table-text">Loan Name</p>
          <p class="table-data">{{ student.loan_name }}</p>
          <p class="table-text">Min Payment</p>
          <p class="table-data">${{ student.minimum_payment_amount }}</p>
          <p class="table-text">Origination</p>
          <p class="table-data">{{ student.origination_date }}</p>
        </div>
      </div>
      <div class="modal">
        <div class="redeem" v-if="student.currentBalance == 0">
          <button v-if="!isHidden" v-on:click="isHidden = true" @click="start(index)">Redeem Reward</button>
        </div>
        <modal name="reward" class="reward" :scrollable="true">
          <div>
            <img :src="require('@/assets/' + '019-trophy' + '.png')" alt />
          </div>
          <div slot="top-right">
            <button class="closer" @click="stop(index)">✕</button>
          </div>
        </modal>

      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import PlaidLink from "vue-plaid-link";
import LineChart from "@/LineChart.js";
// import MyModal from "../components/MyModal";
import VueConfetti from "vue-confetti";

export default {
  name: "loans",
  components: {
    PlaidLink,
    // "my-modal": MyModal,
    LineChart,
    VueConfetti
  },
  created() {
    if (firebase.auth().currentUser.uid == "T4mry1FFWYXeCgwIr9pTlP0ocTu1") {
      this.liabs = [
        {
          account_id: "dbBZKq7bBBi6jjj6EnzqT0wqaRmANYUbJ3mm7",
          account_number: "3917668837",
          last_payment_date: "2019-10-01",
          currentBalance: 632,
          guarantor: "SALLIE MAE",
          interest_rate_percentage: 6.55,
          loan_name: "SALLIE MAE",
          minimum_payment_amount: 67.45,
          origination_date: "2009-08-27",
          origination_principal_amount: 2000,
          outstanding_interest_amount: 0
        }
      ];
    } else {
      this.liabs = [];
    }
    this.setLiabilities();
  },
  data() {
    return {
      liabs: [],
      isHidden: false,
      rollAnimation: "roll-70",
      images: [
        "019-trophy"
      ]
    };
  },
  props: ["api"],
  methods: {
    rollNumber(orig, currentBalance) {
      let n = ((orig - currentBalance) / orig) * 100;
      if (currentBalance == 0) {
        return 100;
      } else {
        let rounded = Math.ceil((n + 1) / 10) * 10;
        return rounded;
      }
    },
    setLiabilities() {
      this.$props.api.response.map(d => {
        let student;
        for (student of d.liabilities.student) {
          let account = d.accounts.find(
            e => e.account_id == student.account_id
          );
          student.currentBalance = account.balances.current;
          this.liabs.push(student);
        }
      });
    },
    start(index) {
      this.$confetti.start({
        defaultColors: ["red", "pink", "#ba0000"],
        particlesPerFrame: 1,
        defaultDropRate: 7,
        defaultSize: 4
      });
      this.$modal.show(`reward`);
    },
    stop(index) {
      this.$confetti.stop();
      this.$modal.hide(`reward`);
    }
  }
};
</script>

<style lang="scss">
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.1) !important;
}

.v--modal {
  box-shadow: unset !important;
  background-color: unset !important;
}
.loans {
  .modal {
    .redeem {
      text-align: center;
    }

    .reward {
      div {
        img {
          left: 44%;
          position: relative;
          width: 50%;
        }
      }
      .closer {
        color: white;
        font-size: 2rem;
      }
    }
  }

  #confetti {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }
  .header {
    font-family: var(--sans);
    padding: 0 2rem;
  }
  .card-container {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    padding: 1rem;
    width: 80%;
    margin: auto;
    margin-bottom: 1rem;
    .card-topline {
      display: flex;
      justify-content: space-between;
      .card-title {
        font-family: var(--sans);
      }
      .card-total {
        font-family: var(--serif);
        text-transform: uppercase;
        span {
          font-family: var(--mono);
        }
      }
    }
    #progress-bar {
      position: relative;
      width: 0;
      height: 20px;
      border-radius: 0.8em;
      animation: roll-100 0.75s ease-in 1 forwards;
    }

    .green {
      border: 1px solid rgba(0, 0, 0, 0.8);
      background: repeating-linear-gradient(
        -45deg,
        var(--green),
        var(--green) 20px,
        var(--mint) 20px,
        var(--mint) 40px
      );
      box-shadow: inset 0 10px 10px rgba(255, 255, 255, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.3),
        inset 0 -5px 3px rgba(0, 0, 0, 0.2), 0 3px 2px rgba(0, 0, 0, 0.3);
    }

    .red {
      border: 1px solid rgba(0, 0, 0, 0.8);
      background: repeating-linear-gradient(
        -45deg,
        red,
        red 20px,
        orangered 20px,
        orangered 40px
      );
      box-shadow: inset 0 10px 10px rgba(255, 255, 255, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.3),
        inset 0 -5px 3px rgba(0, 0, 0, 0.2), 0 3px 2px rgba(0, 0, 0, 0.3);
    }

    #progress-bar:after {
      width: 300px;
      height: 28px;
      border: 1px solid rgba(0, 0, 0, 0.8);
      background: #333;
      border-radius: 1em;
      display: block;
      content: "";
      position: absolute;
      left: -5px;
      top: -5px;
      z-index: -1;
    }

    @-webkit-keyframes roll-10 {
      0% {
        width: 0;
      }
      100% {
        width: 29px;
      }
    }

    @-webkit-keyframes roll-20 {
      0% {
        width: 0;
      }
      100% {
        width: 58px;
      }
    }

    @-webkit-keyframes roll-30 {
      0% {
        width: 0;
      }
      100% {
        width: 87px;
      }
    }

    @-webkit-keyframes roll-40 {
      0% {
        width: 0;
      }
      100% {
        width: 116px;
      }
    }

    @-webkit-keyframes roll-50 {
      0% {
        width: 0;
      }
      100% {
        width: 145px;
      }
    }

    @-webkit-keyframes roll-60 {
      0% {
        width: 0;
      }
      100% {
        width: 174px;
      }
    }

    @-webkit-keyframes roll-70 {
      0% {
        width: 0;
      }
      100% {
        width: 203px;
      }
    }

    @-webkit-keyframes roll-80 {
      0% {
        width: 0;
      }
      100% {
        width: 232px;
      }
    }

    @-webkit-keyframes roll-90 {
      0% {
        width: 0;
      }
      100% {
        width: 261px;
      }
    }

    @-webkit-keyframes roll-100 {
      0% {
        width: 0;
      }
      100% {
        width: 290px;
      }
    }

    .card {
      border-radius: 15px;
      padding: 1rem;
      .table {
        display: grid;
        grid-template-columns: 1fr 1fr;
        p {
          margin: 0;
        }
        .table-text {
          font-family: var(--serif);
        }
        .table-data {
          font-family: var(--mono);
        }
      }
    }
  }
}
</style>